//let DbFunctions = require('./dbfunctions').DbFunctions
let okeResponse = require('okeoke.standardresponse')
let moment = require('moment')
let { UUID } = require("uuidjs")
import { storeTransaction, getTransactionDB, getShiftTransactionsDB, getDocumentTransactionsDB, getUnsyncedTransactions, cleanupTransactions } from '../../IDB/transactions'
import ordereduuid from '../../Helpers/timeuuid'
import merge from 'lodash.merge'

let Transactions = function (clientSocket, client) {
  const uid = UUID.generate()

  const callbacks = {
    onTransactionUpdated: {}
  }

  function addCallback(cbName, name, func) {
    try {
      callbacks[cbName][name] = func
    } catch (e) {
      console.error('Invalid callback name in - add (Orders)', cbName)
    }
  }

  function removeCallback(cbName, name) {
    try {
      delete callbacks[cbName][name]
    } catch (e) {
      console.error('Invalid callback name in - remove (Orders)', cbName)
    }
  }

  function callCallbacks(cbName, message) {
    if (callbacks[cbName] == null) return
    for (let callback of Object.values(callbacks[cbName] || {})) {
      if (typeof callback === 'function') {
        try {
          callback(message)
        } catch (e) {
          console.error(e)
        }
      }
    }
  }

  async function syncTransaction(transaction) {
    return new Promise((resolve, reject) => {
      if (!clientSocket.authorized) {
        transaction.syncneeded = 1
        console.log('NOT CONNECTED', transaction.uuid, transaction.syncneeded)
        storeTransaction(transaction)
        resolve({ success: false, message: 'Client not connected!' })
      } else {
        let done = false
        setTimeout(() => {
          if (!done) {
            transaction.syncneeded = 1
            console.log('TIMEOUT', transaction.uuid, transaction.syncneeded)
            storeTransaction(transaction)
          }
          resolve({ success: false, message: 'Timeout!', code: 408, data: { errMsgCode: 'request.error.timeout' } })
        }, 5000)
        clientSocket.ioclient.emit(
          'syncTransaction',
          {
            transaction
          },
          (e) => {
            //console.log('syncTransaction', e)
            done = true
            if (!e.success) {
              transaction.syncneeded = 1
              //console.log('UNSUCCESSFUL', transaction)
              storeTransaction(transaction)
            } else {
              transaction.syncneeded = 0
              //console.log('SUCCESSFUL', transaction)
              storeTransaction(transaction)
            }
            resolve(e)
          }
        )
      }
    })
  }

  async function addTransaction(shiftUUID, documentUUID, amount, agentID, agentType, agentSubType, extTransactionID) {
    //if (!client.localUser?.userUUID) return okeResponse(false, 400, 'No user logged in', null)
    if (!client.tokenData?.deviceUUID) return okeResponse(false, 400, 'No device inited', null)
    let newTransaction = {
      uuid: ordereduuid(),
      deviceUUID: client.tokenData?.deviceUUID,
      shiftUUID: shiftUUID,
      documentUUID,
      amount,
      agentID,
      agentType,
      agentSubType, 
      extTransactionID,
      transactionTimestamp: new Date().getTime(),
      sysUserUUID: client.localUser?.userUUID || null,
      syncneeded: 1
    }
    await storeTransaction(newTransaction)
    //console.log({ newTransaction })
    callCallbacks('onTransactionUpdated', newTransaction)
    syncTransaction(newTransaction)
    return okeResponse(true, 201, 'Inserted', { ...newTransaction })
  }

  async function updateTransaction(transaction) {
    let existing = await getTransaction(transaction.uuid)
    if(!existing.success) return okeResponse(false, 404, 'Not found', null)
    let updated = merge(existing.data, transaction)
    updated.syncneeded = 1
    callCallbacks('onTransactionUpdated', updated)
    syncTransaction(updated)
    return res
  }

  async function syncOffline() {
    let transactions = await getUnsyncedTransactions()
    //console.log({ transactions })
    for await (let trx of transactions) {
      await syncTransaction(trx)
    }
  }

  function onConnectionChange(data) {
    switch (data.state) {
      case 'Authorized':
        syncOffline()
        break
      default:
        break
    }
  }

  async function init(shift) {
    if(!client.offlineEnabled) return
    let connected = clientSocket.authorized
    clientSocket.addCallback('onConnectionChange', uid, onConnectionChange)
    //console.log({shift})
    await cleanupTransactions(shift?.uuid && shift.shiftEnd == null ? shift.uuid : null)
    if(connected) syncOffline()
  }

  async function getShiftTransactions(shiftUUID) {
    let transactions = await getShiftTransactionsDB(shiftUUID)
    return okeResponse(true, 200, 'Success', transactions)
  }

  async function getDocumentTransactions(documentUUID) {
    let transactions = await getDocumentTransactionsDB(documentUUID)
    return okeResponse(true, 200, 'Success', transactions)
  }

  async function getTransaction(uuid) {
    let transactions = await getTransactionDB(uuid)
    if(!transactions) return okeResponse(false, 404, 'Not found', null)
    return okeResponse(true, 200, 'Success', transactions)
  }

  return {
    addCallback,
    removeCallback,
    init,
    addTransaction,
    updateTransaction,
    getShiftTransactions,
    getDocumentTransactions,
    getTransaction,
    storeTransaction
  }
}

export { Transactions }